import { render, staticRenderFns } from "./BannerCarouselSlick.vue?vue&type=template&id=300b6458&scoped=true"
import script from "./BannerCarouselSlick.vue?vue&type=script&lang=js"
export * from "./BannerCarouselSlick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300b6458",
  null
  
)

export default component.exports